export default function({ app }) {
    /**
     * set cookie _drushimvue for Load balancer
     */
    // app.$cookies.set('drushim_vue', 30, {
    //     path: '/'
    // })

    /**
     * fetch favorites jobs coded  from @drushimJobs and commit to store
     */

    let jobCodesArr = app.$cookies.get('drushimJobs')
    if (jobCodesArr) {
        jobCodesArr
            .toString()
            .split(',')
            .forEach(element => {
                if (Number(element) > 0) {
                    app.context.store.commit('ADD_JOB_TO_FAVORITES', Number(element))
                }
            })
    }
}